/**
 * Força `overflow: hidden` em todo ancestral até `<html>`, e reverte depois.
 *
 * Extraído de `view-chat.vue` (achado de 500 linhas do review de
 * design-system do PR #2041) — utilitário de DOM puro, sem dependência de
 * nenhum outro estado do componente além de `this.$el`. A mesma lógica
 * também está duplicada em `view-atendimento.vue`/`view-crm-emails.vue`;
 * migrá-los pra este mixin é fast-follow natural, fora do escopo desta
 * extração (não expandir o diff pra arquivos que este PR não toca hoje).
 *
 * Contrato do consumidor: chamar `this.lockAncestorOverflow()` em `mounted`
 * e `this.unlockAncestorOverflow()` em `beforeDestroy`.
 */
export const bloqueioOverflowAncestralMixin = {
  data() {
    return {
      // Ancestrais com overflow forçado em mounted() — revertidos em
      // beforeDestroy(). Ver lockAncestorOverflow().
      modifiedAncestors: [],
    }
  },
  methods: {
    // Força overflow:hidden em todo ancestral até <html> — garante que só os
    // cards internos (sidebar/mensagens) rolem, nunca a janela/documento.
    lockAncestorOverflow() {
      this.$nextTick(() => {
        const el = this.$el
        if (!el) return
        // Idempotente: um segundo lock sem unlock empilharia `prev: 'hidden'`
        // e o unlock restauraria `hidden` — a página ficava travada.
        if (this.modifiedAncestors.length) return
        let node = el.parentElement
        while (node) {
          this.modifiedAncestors.push({ node, prev: node.style.overflow })
          node.style.overflow = 'hidden'
          if (node === document.documentElement) break
          node = node.parentElement
        }
      })
    },
    unlockAncestorOverflow() {
      this.modifiedAncestors.forEach(({ node, prev }) => {
        if (node && node.style) node.style.overflow = prev || ''
      })
      this.modifiedAncestors = []
    },
  },
}
